function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "children", "isFullWidth", "isSticky", "brand", "isFullBackground", "appName", "panelFromLinkBreakpoint", "overlayIsOpen", "brandLinkProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import "./floatingHeader.css";
import { GridRow, GridCol } from '@lmig/lmds-react-grid';
import { ButtonOrLink } from '@lmig/lmds-react-button-or-link';
import { LOGOS } from './constants';
import { HeaderAppName } from './components/HeaderAppName';
import { FloatingHeaderContext } from './context/FloatingHeaderContext';
import { useActiveMenu } from './hooks/useActiveMenu';
import { useMinBreakpoint } from './hooks/useMinBreakpoint';
import { HeaderNavigationContext } from './context/HeaderNavigationContext';
import { LogoWrapper } from './components/LogoWrapper';
/**
 * @see [LMDS FloatingHeader Documentation and Examples](https://designsystem.lmig.com/experimental/floating-header/code)
 *
 * API:
 *
 * @implements [FloatingHeaderProps](https://designsystem.lmig.com/experimental/floating-header/code#floating-header-props)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */
export var FloatingHeader = function FloatingHeader(props) {
  var id = props.id,
    className = props.className,
    children = props.children,
    _props$isFullWidth = props.isFullWidth,
    isFullWidth = _props$isFullWidth === void 0 ? false : _props$isFullWidth,
    _props$isSticky = props.isSticky,
    isSticky = _props$isSticky === void 0 ? false : _props$isSticky,
    _props$brand = props.brand,
    brand = _props$brand === void 0 ? 'liberty' : _props$brand,
    _props$isFullBackgrou = props.isFullBackground,
    isFullBackground = _props$isFullBackgrou === void 0 ? false : _props$isFullBackgrou,
    appName = props.appName,
    _props$panelFromLinkB = props.panelFromLinkBreakpoint,
    panelFromLinkBreakpoint = _props$panelFromLinkB === void 0 ? 'lg' : _props$panelFromLinkB,
    _props$overlayIsOpen = props.overlayIsOpen,
    overlayIsOpen = _props$overlayIsOpen === void 0 ? false : _props$overlayIsOpen,
    brandLinkProps = props.brandLinkProps,
    otherProps = _objectWithoutProperties(props, _excluded);

  // This hook is used within HeaderNavigation to ensure only one menu is open within the 'desktop view'
  var _useActiveMenu = useActiveMenu(),
    activeMenuID = _useActiveMenu.activeMenuID,
    setActiveMenuID = _useActiveMenu.setActiveMenuID;
  var breakpointFinal = panelFromLinkBreakpoint || 'never';
  var showHorizontalMenu = useMinBreakpoint(breakpointFinal);
  var singleBrandClass = "lmig-FloatingHeader-brand--".concat(brand);
  var containerClasses = classNames('lmig-FloatingHeader', className, "lmig-FloatingHeader--".concat(brand), {
    'lmig-FloatingHeader--isSticky': isSticky,
    'lmig-FloatingHeader--isFullWidth': isFullWidth,
    'lmig-FloatingHeader--bg-full': isFullBackground
  });
  // lmig-FloatingHeader-inner--${brand} added to modify link color for now.
  var innerClasses = classNames('lmig-FloatingHeader-inner', "lmig-FloatingHeader-inner--".concat(brand), _defineProperty({}, "lmig-FloatingHeader-inner--bg-full--".concat(brand), isFullBackground), /** This applies modifier to inner div to apply border radius if the overlayNav menu is open or a HeaderParentItem is expanded. */
  {
    'lmig-FloatingHeader-inner--overlayIsOpen': overlayIsOpen && !showHorizontalMenu || activeMenuID !== ''
  });
  var brandClasses = classNames('lmig-FloatingHeader-brand', _defineProperty({}, singleBrandClass, !isFullBackground));
  var logoClasses = classNames('lmig-FloatingHeader-brand-logo', "lmig-FloatingHeader-brand-logo--".concat(brand));
  var DisplayLogo = LOGOS[brand];
  var logoProps = brand === 'safeco' && {
    color: 'inverse'
  };
  var LogoContainer = brandLinkProps ? ButtonOrLink : LogoWrapper;
  var logoContainerProps = brandLinkProps ? _objectSpread({}, brandLinkProps) : {};
  var innerFloatingHeader = /*#__PURE__*/React.createElement("div", {
    className: innerClasses
  }, /*#__PURE__*/React.createElement(LogoContainer, _extends({}, logoContainerProps, {
    className: brandClasses
  }), /*#__PURE__*/React.createElement(DisplayLogo, _extends({
    className: logoClasses
  }, logoProps))), appName && /*#__PURE__*/React.createElement(HeaderAppName, {
    hideDivider: !isFullBackground
  }, appName), children);
  return /*#__PURE__*/React.createElement(FloatingHeaderContext.Provider, {
    value: {
      overlayIsOpen: overlayIsOpen,
      showHorizontalMenu: showHorizontalMenu
    }
  }, /*#__PURE__*/React.createElement(HeaderNavigationContext.Provider, {
    value: {
      activeMenuID: activeMenuID,
      setActiveMenuID: setActiveMenuID
    }
  }, /*#__PURE__*/React.createElement("header", _extends({
    id: id,
    className: containerClasses
  }, otherProps), isFullWidth ? innerFloatingHeader : /*#__PURE__*/React.createElement(GridRow, {
    mainGrid: !isFullWidth
  }, /*#__PURE__*/React.createElement(GridCol, {
    base: 12
  }, innerFloatingHeader)))));
};
FloatingHeader.propTypes = {
  /** Header content is rendered inside `<header class="lmig-FloatingHeader">`. */children: _pt.node,
  /**
     * If an edge-to-edge, gridless header is desired, set this to true.
     * @default false
     */
  isFullWidth: _pt.bool,
  /** Determines whether the header should be sticky when scrolling down a page.
     * @default false
     */
  isSticky: _pt.bool,
  /** Determines whether the header background spans the entire width of the header.
     * @default false
     */
  isFullBackground: _pt.bool,
  /**
     * Application name to display next to the brand logo in the `FloatingHeader`.
     */
  appName: _pt.node,
  /** At or above this breakpoint, the menu switches from vertical to horizontal. If this breakpoint is null, the vertical menu will always be used. If this breakpoint is 'base', the horizontal menu will always be used.
     * @default false
     */
  overlayIsOpen: _pt.bool
};